import  {useEffect} from 'react';
import {getFromHubNew} from "../../actions/networkActions";
import browserHistory from "../../utils/history";

function FeedbackGeneric(props) {
    useEffect(() => {
        const fetchConfig = async () => {
            const configResponse = await getFromHubNew(`ratings/config`);
            browserHistory.replace(configResponse.useAnonymousMode ? "/ratings/overview" : "/userratings/overview")
        }

        fetchConfig();
    })

    return null;
}

export default FeedbackGeneric;